import { ReplaySubject } from 'rxjs';
import { BaseModel } from '../../../../../../core/_base/crud';
import { ViTriNhan, ViTriXuat } from '../../../chuc-nang-kho/phieu-chuyen-kho/phieu-chuyen-kho-model/phieu-chuyen-kho.model';

export class ChuyenKhoNoiBoMaster extends BaseModel{
	IdCknb: number
	SoPhieu: string
	NgayChuyen: string
	NgayTao: string
	NguoiTao: number
	TenNguoitao: string
	listDetail: ChuyenKhoNoiBoDetail[];
	LoaiPhieuIn: string;
	clear(){
		this.IdCknb = 0;
		this.SoPhieu = '';
		this.NgayChuyen = '';
		this.NgayTao = '';
		this.NguoiTao = 0;
		this.TenNguoitao = '';
		this.listDetail = [];
		this.LoaiPhieuIn = ''
	}

	copy(item: ChuyenKhoNoiBoMaster){
		this.IdCknb = item.IdCknb;
		this.SoPhieu = item.SoPhieu;
		this.NgayChuyen = item.NgayChuyen;
		this.NgayTao = item.NgayTao;
		this.NguoiTao = item.NguoiTao;
		this.TenNguoitao = item.TenNguoitao;
		this.listDetail = item.listDetail;
		this.LoaiPhieuIn = item.LoaiPhieuIn;
	}
}

export class ChuyenKhoNoiBoDetail {
	IdCtCknb: number
	IdCknb: number
	IdHh: number
	IdLo: number
	TenHH: string
	MaHH: string
	IdKhoChuyen: number
	TenKhoChuyen: string
	ViTriKhoChuyen: string
	LotChuyen: number
	SoLo: string
	SoLuongChuyenGoc: number
	SoLuongChuyenQuiDoi: number
	DvtGoc: number
	DvtQuiDoi: number
	TiLeQuiDoi: number
	TenDVTQuiDoi: string
	IdKhoNhan: number
	ViTriKhoNhan: string
	TenKhoNhan: string
	GhiChu: string
	IdTk: number
	SoMay: string
	SoMeSoXe: string
	MaThung: string
	NgayDongThung: string
	listDVTInfo: any[]
	PalletChuyen: string
	PalletNhan: string
	ListKhoChuyen: any[]
	ListViTriChuyen: ViTriXuat[];
	ListViTriNhan: ViTriNhan[];
	ListLOTc: any[];
	filteredLOTC: ReplaySubject<any[]>;
	ListLOTn: any[];
	ListPalletC: any[];
	isError: boolean
	tonkhohientai_id: number
	Ngaysanxuat: string;
	Hansudung: string
	NgayDongThungEnabled: boolean
	clear(){
		this.IdCtCknb = 0;
		this.IdCknb = 0;
		this.IdHh = 0;
		this.IdLo = 0;
		this.TenHH = '';
		this.MaHH = '';
		this.IdKhoChuyen = 0;
		this.TenKhoChuyen = '';
		this.ViTriKhoChuyen = '';
		this.LotChuyen = 0;
		this.SoLo = '';
		this.SoLuongChuyenGoc = 0;
		this.SoLuongChuyenQuiDoi = 0;
		this.DvtGoc = 0;
		this.DvtQuiDoi = 0;
		this.TiLeQuiDoi = 0;
		this.TenDVTQuiDoi = '';
		this.IdKhoNhan = 0;
		this.ViTriKhoNhan = '';
		this.TenKhoNhan = '';
		this.GhiChu = '';
		this.IdTk = 0;
		this.SoMay = '';
		this.listDVTInfo = [];
		this.ListViTriChuyen = [];
		this.ListViTriNhan = [];
		this.ListLOTc = [];
		this.filteredLOTC = new ReplaySubject<any[]>(1);
		this.ListLOTn = [];
		this.ListPalletC = [];
		this.PalletChuyen = '';
		this.PalletNhan = '';
		this.isError = false;
		this.ListKhoChuyen = []
		this.tonkhohientai_id = 0;
		this.Ngaysanxuat = '';
		this.Hansudung = '';
		this.MaThung = '';
		this.NgayDongThungEnabled = false;
	}

	copy(item: ChuyenKhoNoiBoDetail){
		this.IdCtCknb = item.IdCtCknb;
		this.IdCknb = item.IdCknb;
		this.IdHh = item.IdHh;
		this.TenHH = item.TenHH;
		this.MaHH = item.MaHH;
		this.IdKhoChuyen = item.IdKhoChuyen;
		this.TenKhoChuyen = item.TenKhoChuyen;
		this.ViTriKhoChuyen = item.ViTriKhoChuyen;
		this.LotChuyen = item.LotChuyen;
		this.IdLo = item.IdLo;
		this.SoLo = item.SoLo;
		this.SoLuongChuyenGoc = item.SoLuongChuyenGoc;
		this.SoLuongChuyenQuiDoi = item.SoLuongChuyenQuiDoi;
		this.DvtGoc = item.DvtGoc;
		this.DvtQuiDoi = item.DvtQuiDoi;
		this.TiLeQuiDoi = item.TiLeQuiDoi;
		this.TenDVTQuiDoi = item.TenDVTQuiDoi;
		this.IdKhoNhan = item.IdKhoNhan;
		this.ViTriKhoNhan = item.ViTriKhoNhan;
		this.TenKhoNhan = item.TenKhoNhan;
		this.GhiChu = item.GhiChu;
		this.IdTk = item.IdTk;
		this.SoMay = item.SoMay;
		this.listDVTInfo = item.listDVTInfo;
		this.PalletChuyen = item.PalletChuyen;
		this.PalletNhan = item.PalletNhan;
		this.listDVTInfo = item.listDVTInfo;
		this.ListViTriChuyen = item.ListViTriChuyen;
		this.ListViTriNhan = item.ListViTriNhan;
		this.ListLOTc = item.ListLOTc;
		this.ListLOTn = item.ListLOTn;
		this.ListPalletC = item.ListPalletC;
		this.SoMeSoXe = item.SoMeSoXe;
		this.MaThung = item.MaThung;
		this.NgayDongThung = item.NgayDongThung;
		this.ListKhoChuyen = item.ListKhoChuyen
		this.tonkhohientai_id = item.tonkhohientai_id
		this.filteredLOTC = item.filteredLOTC
		this.Hansudung = item.Hansudung;
		this.Ngaysanxuat = item.Ngaysanxuat
		this.NgayDongThungEnabled = item.NgayDongThungEnabled;

	}
}

export const PARAM_NGAYCGHUYEN: string = "NgayChuyen";
export const PARAM_MAHANG: string = "MaHang";
export const PARAM_IDKHOCHUYEN: string = "IdKhoChuyen";
export const PARAM_VTKCHUYEN: string = "ViTriKhoChuyen";
export const PARAM_LOTCHUYEN: string = "LotChuyen";
export const PARAM_PALLETCHUYEN: string = "PalletChuyen";
export const PARAM_SLQUIDOI: string = "SoLuongChuyenQuiDoi";
export const PARAM_DVTQUIDOI: string = "DvtQuiDoi";
export const PARAM_IDKHONHAN: string = "IdKhoNhan";
export const PARAM_VTKNHAN: string = "ViTriKhoNhan";
export const PARAM_GHICHU: string = "GhiChu";
export const PARAM_PALLETNHAN: string = "PalletNhan";
export const PARAM_SOMESOXE: string = "SoMeSoXe";
export const PARAM_SOMAY: string = "SoMay";
export const PARAM_MATHUNG: string = "MaThung";